import React, { Fragment } from 'react';
import { Form, Input } from 'antd';
const Vin = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">VIN:</span>
      <Form.Item>
        {getFieldDecorator('vin', {
            validateTrigger: 'onBlur',
            rules: [{
                validator: (rule, value, callback) => {
                    if (value && typeof value === 'string' && value.length < 17) {
                        callback('VIN номер ТС должен быть длиной 17 знаков')
                    } else {
                        callback();
                    }

                }
            }]
        })(
          <Input
            maxLength={17}
            className="longInput"
            placeholder="Укажите VIN-номер"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </Fragment>
  );
};

export default Vin;
